var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 20H44V14C44 10.8174 42.7357 7.76515 40.4853 5.51472C38.2348 3.26428 35.1826 2 32 2C28.8174 2 25.7652 3.26428 23.5147 5.51472C21.2643 7.76515 20 10.8174 20 14V20H12C10.9391 20 9.92172 20.4214 9.17157 21.1716C8.42143 21.9217 8 22.9391 8 24V52C8 53.0609 8.42143 54.0783 9.17157 54.8284C9.92172 55.5786 10.9391 56 12 56H52C53.0609 56 54.0783 55.5786 54.8284 54.8284C55.5786 54.0783 56 53.0609 56 52V24C56 22.9391 55.5786 21.9217 54.8284 21.1716C54.0783 20.4214 53.0609 20 52 20ZM24 14C24 11.8783 24.8429 9.84344 26.3431 8.34315C27.8434 6.84285 29.8783 6 32 6C34.1217 6 36.1566 6.84285 37.6569 8.34315C39.1571 9.84344 40 11.8783 40 14V20H24V14ZM52 52H12V24H52V52ZM35 38C35 38.5933 34.8241 39.1734 34.4944 39.6667C34.1648 40.1601 33.6962 40.5446 33.148 40.7716C32.5999 40.9987 31.9967 41.0581 31.4147 40.9424C30.8328 40.8266 30.2982 40.5409 29.8787 40.1213C29.4591 39.7018 29.1734 39.1672 29.0576 38.5853C28.9419 38.0033 29.0013 37.4001 29.2284 36.852C29.4554 36.3038 29.8399 35.8352 30.3333 35.5056C30.8266 35.1759 31.4067 35 32 35C32.7956 35 33.5587 35.3161 34.1213 35.8787C34.6839 36.4413 35 37.2043 35 38Z",
    fill: "#F4831F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.6d3b0b86.svg";
export { ForwardRef as ReactComponent };